// base phraseapp/react-intl
import { FormattedDate, FormattedTime, FormattedRelative, FormattedNumber, FormattedPlural } from "react-intl";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl-phraseapp";
import FormattedCurrency from "./common/FormattedCurrency";
// in-context phraseapp/react-intl elements
import inContextEditor from "./service/inContext";
import Loader from "./Loader";
import { injectIntl } from "./injectIntl";
import getSupportedLocale from "./helpers/getSupportedLocale";
import supportedLocal from "./helpers/supported.json";
import getResolvedMessage from "./helpers/getResolvedMessage";
import getMessage from "./helpers/getMessage";
export { inContextEditor, Loader as LangLoader, supportedLocal, getSupportedLocale, injectIntl, FormattedDate, FormattedTime, FormattedRelative, FormattedNumber, FormattedCurrency, FormattedPlural, FormattedMessage, FormattedHTMLMessage, getResolvedMessage, getMessage };
export default FormattedMessage;
